export interface VendorTabOption {
  vendorCode: string;
  vendorName: string;
}

// Beyond this many vendors the buttons give way to a dropdown, on every page that switches vendor.
export const VENDOR_TABS_MAX = 3;

export type VendorSwitcher = 'none' | 'tabs' | 'select';

// hideSingle: a page whose only vendor needs no switcher (the PO Tracker); Scheduling keeps its lone tab.
export function vendorSwitcher(count: number, hideSingle: boolean): VendorSwitcher {
  if (count === 0 || (hideSingle && count === 1)) return 'none';
  return count > VENDOR_TABS_MAX ? 'select' : 'tabs';
}

export function vendorOptionLabel(option: VendorTabOption): string {
  return option.vendorCode === option.vendorName ? option.vendorName : `${option.vendorCode} — ${option.vendorName}`;
}

// Code ascending, the order the backend gives Scheduling's calendar lanes, so every vendor row agrees.
export function sortVendorOptions<T extends VendorTabOption>(options: T[]): T[] {
  return [...options].sort((a, b) => a.vendorCode.localeCompare(b.vendorCode));
}
